import http from './_http'

const auth = {
  // token: () => http.get('auth/token'), // not used
  login: (m) => { return http.post('auth/user/login', m); },
  profile: (m) => { return http.post('auth/user/profile', m); },
  get: (m) => { return http.post('auth/user/profile/get', m); },
  preflight: (m) => { return http.post('auth/user/preflight', m); },
  update: (m) => { return http.post('auth/user/profile/update', m); },
  // pwd_update: (m) => { return http.post('auth/user/password/update', m); },
  refresh: () => { return http.get('auth/user/refresh/' + new Date().getTime()); },
  setAuth: (token) => { http.defaults.headers.common['Authorization'] = 'Bearer ' + token; },
  unsetAuth: () => { delete http.defaults.headers.common['Authorization']; },
  // regist : (m) => { return http.post('auth/user/regist/',m); },
  otpGen : (m) => { return http.post('auth/user/otp/gen',m); },
  checkPasswordCycle: (m) => { return http.post('auth/user/cycle/password', m); },
  otpVerify : (m) => { return http.post('auth/user/otp/verify', m); },
  otpRegister : (m) => { return http.post('auth/user/otp/register', m); },
  otpUnregister : (m) => { return http.post('auth/user/otp/unregister', m); },
  otpUpdate : (m) => { return http.post('auth/user/otp/update',m); },
  ResetPassword : (m) => { return http.post('auth/user/reset/password', m); },


  tokenReset : (m) => { return http.post('auth/user/reset/token', m); },
  tokenVerify : (m) => { return http.post('auth/user/reset/verify', m); },

  license : (m) => { return http.post('auth/user/license/once', m); },
  licenseAgentInstall : (m) => { return http.post('auth/user/license/agent', m); }

}

export default auth
